import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { AngularDatasModule, AuthService } from '@univacity/angular/datas';
import {
  AngularUiModule,
  DestroyAbleComponent,
  Menu,
} from '@univacity/angular/ui';
import { RoutePath } from '@univacity/shared/types';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { takeUntil } from 'rxjs';
import { AuthModalsService } from '../../auth/auth-modals.service';

@Component({
  selector: 'un-user-nav',
  imports: [
    CommonModule,
    NgOptimizedImage,
    NzDropDownModule,
    RouterModule,
    AngularUiModule,
    AngularDatasModule,
  ],
  templateUrl: './user-nav.component.html',
  styleUrls: ['./user-nav.component.less'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class UserNavComponent extends DestroyAbleComponent implements OnInit {
  @Input() menus: Menu[] = [];

  constructor(
    public auth: AuthService,
    public authModal: AuthModalsService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.auth.user$
      .pipe(takeUntil(this.dead$))
      .subscribe(() => this.addLoggedInUserMenu());
  }

  private addLoggedInUserMenu() {
    this.menus = [];
    if (this.auth.isLoggedIn)
      this.menus = [
        {
          text: $localize`Dashboard`,
          icon: 'dashboard',
          iconTheme: 'outline',
          link: RoutePath.dashboard,
        },
        {
          text: $localize`Applications`,
          icon: 'form',
          iconTheme: 'outline',
          link: RoutePath.dashboardApplications,
        },
        {
          text: $localize`Bookings`,
          icon: 'calendar',
          iconTheme: 'outline',
          link: RoutePath.dashboardTourBookings,
        },
        {
          text: $localize`Invoice`,
          icon: 'calculator',
          iconTheme: 'outline',
          link: RoutePath.dashboardInvoices,
        },
        {
          text: $localize`Settings`,
          icon: 'setting',
          iconTheme: 'outline',
          link: RoutePath.dashboardSettings,
        },
      ];
    this.cdr.detectChanges();
  }
}
